import React from "react";
import Modal from "react-modal";
import { Oval } from "react-loader-spinner";
import toast from "react-hot-toast";

import { useAppSelector, useAppDispatch } from "../../../../../../app/hooks";
import { setRevokingKey, revokeApiKey } from "../../../../apiKeysSlice";

import "./RevokeApiKeyConfirmModal.scss";

const modalStyles = {
  content: {
    top: "50%", left: "50%", right: "auto", bottom: "auto",
    marginRight: "-50%", transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF", maxWidth: "440px",
  },
};

export function RevokeApiKeyConfirmModal() {
  const dispatch = useAppDispatch();
  const revokingKey = useAppSelector((state) => state.apiKeys.revokingKey);
  const revokeAPI = useAppSelector((state) => state.apiKeys.revokeApiKey);

  React.useEffect(() => {
    if (!revokeAPI.loading && !!revokeAPI.error) {
      toast.error("Couldn't revoke the API key. Please try again.");
    }
  }, [revokeAPI.loading, revokeAPI.error]);

  const onClose = () => dispatch(setRevokingKey(undefined));
  const onConfirm = () => {
    if (revokingKey) dispatch(revokeApiKey(revokingKey.id));
  };

  return (
    <Modal isOpen={!!revokingKey} onRequestClose={onClose} style={modalStyles}>
      <div className="revoke-api-key-modal-component">
        <div className="title">Revoke API Key</div>
        <div className="body">
          Revoke <strong>{revokingKey?.name}</strong> (<code>{revokingKey?.keyPrefix}</code>)?
          Any integration using this key will stop working immediately. This cannot be undone.
        </div>
        <div className="actions">
          <button type="button" className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="confirm-button" onClick={onConfirm} disabled={revokeAPI.loading}>
            Revoke
            {revokeAPI.loading && (
              <div style={{ marginLeft: 8 }}>
                <Oval color="#FFFFFF" height={18} width={18} secondaryColor="#FBD20A" />
              </div>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
}
